import { Outlet } from "react-router-dom"

const AdminAdminsScreen = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default AdminAdminsScreen
